import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
    APPROVE_UNBLOCK_VEHICLE_REQ,
    authKey,
    DOWNLOAD_DOCUMENT,
    GET_BLOCKED_TRANSPORTER_VEHICLE_LIST,
} from "../../common/URLs";
import {
    Container,
    Grid,
    Box,
    Card,
    Stack,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    DialogContentText,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { ApproveIcon, ViewIcon } from "../../common/icons";
import apiClient from "../../axios";

function ApproveUnlockVehicleRequest() {

    const [openConfirm, setOpenConfirm] = useState(false);
    const [loading, setLoading] = useState(false);

    const [blockedVehicleList, setBlockedVehicleList] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    useEffect(() => {
        getBlockedTransporterVehicleList()
    }, []);

    const columns = [
        { field: "vehicleBlockedRequestNumber", headerName: "Vehicle Blocked Request Number", width: 220 },
        { field: "stakeholderType", headerName: "Stakeholder Type", width: 130 },
        { field: "stakeholderUrn", headerName: "Stakeholder URN", width: 160 },
        { field: "vehicleNo", headerName: "Vehicle Number", width: 160 },
        {
            field: "vehicleBlockedComment",
            headerName: "Blocked Vehicle Comment",
            width: 360,
        },
        {
            field: "vehicleUnblockedComment",
            headerName: "Unblocked Vehicle Comment",
            width: 360,
        },
        {

    field: "vehicleBlockrequestDocumentList",

    headerName: "Block Documents",

    width: 220,

    renderCell: (params) => {

        const docs = params.row.vehicleBlockrequestDocumentList || [];

        if (!docs.length) return <Typography variant="body2">—</Typography>;

        return (
<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>

                {docs.map((doc, idx) => (
<Button

                        key={idx}

                        size="small"

                        variant="text"

                        onClick={() =>

                            handleDownload(

                                doc.vehicleBlockrequestFileId,

                                doc.vehicleBlockrequestFileName,

                                "Download"

                            )

                        }
>

                        {doc.vehicleBlockrequestFileName || `Doc ${idx + 1}`}
</Button>

                ))}
</Box>

        );

    },

},

{

    field: "vehicleUnBlockrequestDocumentList",

    headerName: "Unblock Documents",

    width: 220,

    renderCell: (params) => {

        const docs = params.row.vehicleUnBlockrequestDocumentList || [];

        if (!docs.length) return <Typography variant="body2">—</Typography>;

        return (
<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>

                {docs.map((doc, idx) => (
<Button

                        key={idx}

                        size="small"

                        variant="text"

                        onClick={() =>

                            handleDownload(

                                doc.vehicleUnBlockrequestFileId,

                                doc.vehicleUnBlockrequestFileName,

                                "Download"

                            )

                        }
>

                        {doc.vehicleUnBlockrequestFileName || `Doc ${idx + 1}`}
</Button>

                ))}
</Box>

        );

    },

},
 
    ];

    const getBlockedTransporterVehicleList = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BLOCKED_TRANSPORTER_VEHICLE_LIST,
                {
                    isRequestSentForUnblock: true,
                    isVehicleBlocked: true,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem("id_token"),
                    },
                }
            )
            .then((response) => {
                const list = (response.data.vehicleBlockedRequestList || []).map((r) => ({
                    ...r,
                    vehicleBlockedComment: r.vehicleBlockedComment || "",
                     vehicleBlockrequestDocumentList: r.vehicleBlockrequestDocumentList || [],
   vehicleUnBlockrequestDocumentList: r.vehicleUnBlockrequestDocumentList || [],
                }));
                setBlockedVehicleList(list);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    const handleDownload = (documentBlobName, finalfileName, type) => {
            loaderService.showLoader();
            return fetch(DOWNLOAD_DOCUMENT,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        AuthKey: authKey,
                    },
                    body: JSON.stringify({
                        "fileName": documentBlobName,
                        "containerName": "pit",
                        "file": ""
                    })
                })
                .then((response) => response.blob()
                )
                .then((blob) => {
                    if (type === "View") {
                        const fileName = finalfileName
                        const splittedName = fileName.split('.')
                        const fileExtension = splittedName[splittedName.length - 1];
                        let fileType;
                        switch (fileExtension) {
                            case 'pdf':
                                fileType = 'application/pdf';
                                break;
                            case 'png':
                                fileType = 'image/png';
                                break;
                            case 'jpg':
                                fileType = 'image/jpeg';
                                break;
                            case 'jpeg':
                                fileType = 'image/jpeg';
                                break;
                            default:
                                fileType = 'application/octet-stream';
                        }
                        const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                        const newWindow = window.open(url, '_blank');
                        newWindow.focus();
                    }
                    else {
                        const a = document.createElement("a");
                        a.style.display = "none";
                        document.body.appendChild(a);
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = finalfileName;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                });
        }

//     const handleDownload = async (fileId, fileName, containerName) => {
//    try {
//        const res = await apiClient.post(
//            DOWNLOAD_DOCUMENT,
//            { blobFileId: fileId, containerName: containerName || "pit" },
//            {
//                headers: { Authorization: "Bearer " + getLocalStorageItem("id_token") },
//                responseType: "blob",
//            }
//        );
//        const url = window.URL.createObjectURL(new Blob([res.data]));
//        const link = document.createElement("a");
//        link.href = url;
//        link.setAttribute("download", fileName || "document");
//        document.body.appendChild(link);
//        link.click();
//        link.remove();
//        window.URL.revokeObjectURL(url);
//    } catch (err) {
//        toast.error("Failed to download document");
//    }
// };

    const handleOpenConfirm = () => {
        if (!rowSelectionModel?.length) {
            toast.error("Please select at least one row");
            return;
        }
        setOpenConfirm(true);
    };

    const handleCloseConfirm = () => {
        if (!loading) setOpenConfirm(false);
    };

    const handleConfirmSubmit = async () => {
        setLoading(true);

        const selectedRows = (blockedVehicleList || []).filter(
            (row) => rowSelectionModel.includes(row.id)
        );

        const payload = selectedRows.map((row) => ({
            vehicleBlockedRequestNumber: row.vehicleBlockedRequestNumber,
            stakeholderType: row.stakeholderType,
            stakeholderUrn: row.stakeholderUrn,
            vehicleNo: row.vehicleNo
        }));

        try {
            const res = await apiClient.post(APPROVE_UNBLOCK_VEHICLE_REQ, {"vehicleUnblockRequestList": payload}, {
                headers: {
                    Authorization: "Bearer " + getLocalStorageItem("id_token"),
                    "Content-Type": "application/json",
                },
            });

            const isOk =
                res?.status === 200 &&
                (res?.data?.isSuccess === true ||
                    res?.data?.success === true ||
                    res?.data?.message === "success");

            if (isOk) {
                toast.success("Successfully Approved");
                setRowSelectionModel([]);
                setOpenConfirm(false);
                getBlockedTransporterVehicleList();
            } else {
                toast.error(res?.data?.message || "Request failed");
            }
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Container maxWidth="xxl">
                <Stack direction={{ xs: "column", sm: "row" }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Approve UnBlock Vehicle Request
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1} >
                        <>
                            <Stack direction="row" spacing={1} mb={1}>
                                <Button startIcon={<ApproveIcon />} variant="contained" sx={{ minWidth: 100 }} disabled={blockedVehicleList?.length < 1} onClick={handleOpenConfirm} >
                                    Approve
                                </Button>
                            </Stack>
                        </>
                    </Stack>
                </Stack>

                <Grid container spacing={3}>
                    <Grid item xs={12} lg={12}>
                        <Card>
                            <Box style={{ height: 450, width: "100%" }}>
                                <DataGrid
                                    getRowHeight={() => "auto"}
                                    rows={blockedVehicleList || []}
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                    pageSize={10}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    disableRowSelectionOnClick
                                    checkboxSelection
                                    selectionModel={rowSelectionModel}
                                    onSelectionModelChange={(newModel) => setRowSelectionModel(newModel)}
                                />
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
            >
                <DialogTitle>Confirm Action</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to proceed with the selected vehicle(s)?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseConfirm} disabled={loading}>
                        Cancel
                    </Button>

                    <Button
                        onClick={handleConfirmSubmit}
                        // variant="contained"
                        color="primary"
                        disabled={loading}
                    >
                        {loading ? "Processing..." : "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    );
}

export default ApproveUnlockVehicleRequest;